export const BETTINGHISTORY_LIST = "BETTINGHISTORY_LIST";
export const BETTINGHISTORY_CANCEL = "BETTINGHISTORY_CANCEL";
export const BETTINGHISTORY_DROPDOWN = "BETTINGHISTORY_DROPDOWN";
export const BETTINGHISTORY_MEMBERREFER = "BETTINGHISTORY_MEMBERREFER";
export const SET_USER_BASICS = 'SET_USER_BASICS';
export const SET_USER_BASICS_FAIL = 'SET_USER_BASICS_FAIL';
